// src/api/gas.js - API para el módulo de recarga de gas
import { apiFetch } from './index.js';

// =====================================================
// ZONAS
// =====================================================
export const obtenerZonas = async (estado = 'all') => {
  try {
    const response = await apiFetch('/api/Zona');
    const data = Array.isArray(response) ? response : (response?.data || []);
    let zonas = data;
    if (estado === 'activas' || estado === 'activo') {
      zonas = data.filter(z => z.estadoZona === 'activo');
    } else if (estado === 'inactivas' || estado === 'inactivo') {
      zonas = data.filter(z => z.estadoZona === 'inactivo');
    }
    return { success: true, data: zonas, count: zonas.length };
  } catch (error) {
    console.error('❌ Error obteniendo zonas:', error);
    return { success: false, error: error?.message || 'Error al obtener zonas', data: [], count: 0 };
  }
};

export const obtenerZonaPorId = async (id) => {
  try {
    const response = await apiFetch(`/api/Zona/${id}`);
    return { success: true, data: response };
  } catch (error) {
    console.error('❌ Error obteniendo zona:', error);
    return { success: false, error: error?.message || 'Error al obtener zona', data: null };
  }
};

export const crearZona = async (data) => {
  try {
    const response = await apiFetch('/api/Zona', { method: 'POST', body: JSON.stringify(data) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Zona creada' };
  } catch (error) {
    console.error('❌ Error creando zona:', error);
    return { success: false, error: error?.message || 'Error al crear zona', data: null };
  }
};

export const actualizarZona = async (id, data) => {
  try {
    const response = await apiFetch(`/api/Zona/${id}`, { method: 'PUT', body: JSON.stringify(data) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Zona actualizada' };
  } catch (error) {
    console.error('❌ Error actualizando zona:', error);
    return { success: false, error: error?.message || 'Error al actualizar zona', data: null };
  }
};

export const eliminarZona = async (id) => {
  try {
    const response = await apiFetch(`/api/Zona/${id}`, { method: 'DELETE' });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Zona eliminada' };
  } catch (error) {
    console.error('❌ Error eliminando zona:', error);
    return { success: false, error: error?.message || 'Error al eliminar zona', data: null };
  }
};

// =====================================================
// TIPOS DE RECARGA
// =====================================================
export const obtenerTiposRecarga = async (estado = 'all') => {
  try {
    const response = await apiFetch('/api/TipoRecarga');
    const data = Array.isArray(response) ? response : (response?.data || []);
    let tipos = data;
    if (estado === 'activos' || estado === 'activo') {
      tipos = data.filter(t => t.estado === 'activo');
    }
    return { success: true, data: tipos, count: tipos.length };
  } catch (error) {
    console.error('❌ Error obteniendo tipos de recarga:', error);
    return { success: false, error: error?.message || 'Error al obtener tipos de recarga', data: [], count: 0 };
  }
};

export const obtenerTipoRecargaPorId = async (id) => {
  try {
    const response = await apiFetch(`/api/TipoRecarga/${id}`);
    return { success: true, data: response };
  } catch (error) {
    console.error('❌ Error obteniendo tipo de recarga:', error);
    return { success: false, error: error?.message || 'Error al obtener tipo de recarga', data: null };
  }
};

export const crearTipoRecarga = async (data) => {
  try {
    const response = await apiFetch('/api/TipoRecarga', { method: 'POST', body: JSON.stringify(data) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Tipo creado' };
  } catch (error) {
    console.error('❌ Error creando tipo de recarga:', error);
    return { success: false, error: error?.message || 'Error al crear tipo de recarga', data: null };
  }
};

export const actualizarTipoRecarga = async (id, data) => {
  try {
    const response = await apiFetch(`/api/TipoRecarga/${id}`, { method: 'PUT', body: JSON.stringify(data) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Tipo actualizado' };
  } catch (error) {
    console.error('❌ Error actualizando tipo de recarga:', error);
    return { success: false, error: error?.message || 'Error al actualizar tipo de recarga', data: null };
  }
};

export const eliminarTipoRecarga = async (id) => {
  try {
    const response = await apiFetch(`/api/TipoRecarga/${id}`, { method: 'DELETE' });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Tipo eliminado' };
  } catch (error) {
    console.error('❌ Error eliminando tipo de recarga:', error);
    return { success: false, error: error?.message || 'Error al eliminar tipo de recarga', data: null };
  }
};

export const convertirKilosALitros = async (kilos) => {
  try {
    const response = await apiFetch(`/api/TipoRecarga/conversion/kilos-a-litros/${kilos}`);
    return { success: true, data: response };
  } catch (error) {
    console.error('❌ Error convirtiendo kilos a litros:', error);
    return { success: false, error: error?.message || 'Error en conversión', data: null };
  }
};

export const convertirLitrosAKilos = async (litros) => {
  try {
    const response = await apiFetch(`/api/TipoRecarga/conversion/litros-a-kilos/${litros}`);
    return { success: true, data: response };
  } catch (error) {
    console.error('❌ Error convirtiendo litros a kilos:', error);
    return { success: false, error: error?.message || 'Error en conversión', data: null };
  }
};

// =====================================================
// ⭐ TASA DE CAMBIO (BCV)
// =====================================================
export const obtenerTasaActual = async () => {
  try {
    const response = await apiFetch('/api/TasacambioVenta/activa');

    console.log('🔍 Respuesta cruda de /activa:', response);

    let data = response?.data ?? response;

    if (data?.data && typeof data.data === 'object') {
      data = data.data;
    }

    if (!data || typeof data !== 'object') {
      console.warn('⚠️ Respuesta inválida de /activa:', data);
      return { success: false, error: 'Sin tasa activa', data: null };
    }

    console.log('🔍 Objeto tasa extraído:', JSON.stringify(data));
    console.log('🔍 Propiedades disponibles:', Object.keys(data));

    const candidatos = [];

    Object.keys(data).forEach(key => {
      const val = data[key];

      if (val === null || val === undefined) return;
      if (typeof val === 'boolean') return;
      if (typeof val === 'object') return;

      const num = Number(val);
      if (isNaN(num)) return;
      if (num <= 0) return;

      const keyLower = key.toLowerCase();
      const esId = keyLower.includes('id') && !keyLower.includes('tasa') && !keyLower.includes('precio');
      if (esId) return;

      candidatos.push({ key, valor: num });
    });

    console.log('🔍 Candidatos encontrados:', candidatos);

    if (candidatos.length === 0) {
      console.warn('❌ No se encontró ningún valor numérico válido');
      return { success: false, error: 'Sin tasa válida', data: null };
    }

    const candidatosTasa = candidatos.filter(c => {
      const k = c.key.toLowerCase();
      return k.includes('precio') || k.includes('tasa') || k.includes('bs') || k.includes('valor');
    });

    const listaFinal = candidatosTasa.length > 0 ? candidatosTasa : candidatos;

    let tasaReal = Math.max(...listaFinal.map(c => c.valor));

    console.log('🔍 Tasa elegida antes de validar:', tasaReal, 'de:', listaFinal);

    if (tasaReal > 0 && tasaReal < 1) {
      tasaReal = Number((1 / tasaReal).toFixed(2));
      console.log('🔍 Tasa invertida:', tasaReal);
    }

    if (tasaReal < 10) {
      console.error('❌ Tasa sospechosamente baja (< 10):', tasaReal, '→ ignorada');
      return { success: false, error: 'Tasa inválida', data: null };
    }

    console.log('✅ Tasa BCV final:', tasaReal);

    return {
      success: true,
      data: {
        precioUsdBs: tasaReal,
        tasaBsUsd: tasaReal,
        fecha: data.fecha || data.Fecha || data.fechaActualizacion || null,
        fuente: data.fuente || data.Fuente || 'BCV'
      }
    };
  } catch (error) {
    console.error('❌ Error obteniendo tasa BCV:', error);
    return {
      success: false,
      error: error?.message || 'Error al obtener la tasa',
      data: null
    };
  }
};

// =====================================================
// CLIENTES DE GAS
// =====================================================
export const obtenerClientesGas = async (estado = 'all') => {
  try {
    const response = await apiFetch('/api/ClienteGas');
    const data = Array.isArray(response) ? response : (response?.data || []);
    let clientes = data;
    if (estado === 'activos' || estado === 'activo') clientes = data.filter(c => c.estado === 'activo');
    else if (estado === 'pendientes') clientes = data.filter(c => c.verificado === false);
    return { success: true, data: clientes, count: clientes.length };
  } catch (error) {
    console.error('❌ Error obteniendo clientes de gas:', error);
    return { success: false, error: error?.message || 'Error al obtener clientes de gas', data: [], count: 0 };
  }
};

export const obtenerClienteGasPorId = async (id) => {
  try {
    const response = await apiFetch(`/api/ClienteGas/${id}`);
    return { success: true, data: response };
  } catch (error) {
    console.error('❌ Error obteniendo cliente de gas:', error);
    return { success: false, error: error?.message || 'Error al obtener cliente', data: null };
  }
};

export const buscarClientePorCedula = async (cedula) => {
  try {
    const response = await apiFetch(`/api/ClienteGas/buscar-por-cedula?cedula=${encodeURIComponent(cedula)}`);
    const data = response?.data ?? response;

    if (!data) {
      return { success: true, data: null, encontrado: false };
    }

    return {
      success: true,
      data,
      encontrado: true,
      message: response?.mensaje || 'Cliente encontrado'
    };
  } catch (error) {
    console.error('❌ Error buscando cliente por cédula:', error);
    if (error?.status === 404 || /404|not found/i.test(error?.message || '')) {
      return { success: true, data: null, encontrado: false };
    }
    return { success: false, error: error?.message || 'Error al buscar cliente', data: null, encontrado: false };
  }
};

export const crearClienteGas = async (data) => {
  try {
    const response = await apiFetch('/api/ClienteGas', { method: 'POST', body: JSON.stringify(data) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Cliente creado' };
  } catch (error) {
    console.error('❌ Error creando cliente de gas:', error);
    return { success: false, error: error?.message || 'Error al crear cliente', data: null };
  }
};

export const actualizarClienteGas = async (id, data) => {
  try {
    const response = await apiFetch(`/api/ClienteGas/${id}`, { method: 'PUT', body: JSON.stringify(data) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Cliente actualizado' };
  } catch (error) {
    console.error('❌ Error actualizando cliente de gas:', error);
    return { success: false, error: error?.message || 'Error al actualizar cliente', data: null };
  }
};

export const eliminarClienteGas = async (id) => {
  try {
    const response = await apiFetch(`/api/ClienteGas/${id}`, { method: 'DELETE' });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Cliente eliminado' };
  } catch (error) {
    console.error('❌ Error eliminando cliente de gas:', error);
    return { success: false, error: error?.message || 'Error al eliminar cliente', data: null };
  }
};

export const verificarClienteGas = async (id, data) => {
  try {
    const response = await apiFetch(`/api/ClienteGas/${id}/verificar`, { method: 'PUT', body: JSON.stringify(data) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Cliente verificado' };
  } catch (error) {
    console.error('❌ Error verificando cliente de gas:', error);
    return { success: false, error: error?.message || 'Error al verificar cliente', data: null };
  }
};

// =====================================================
// REGISTRO WEB CON PEDIDO
// =====================================================
export const registroWebConPedido = async (data) => {
  try {
    console.log('📤 Enviando registro web con pedido:', data);

    const response = await apiFetch('/api/ClienteGas/registro-web', {
      method: 'POST',
      body: JSON.stringify(data)
    });

    console.log('📥 Respuesta del servidor:', response);

    const cliente = response?.data?.cliente || null;
    const pedido = response?.data?.pedido || null;

    if (!cliente || !pedido) {
      console.warn('⚠️ Respuesta del backend sin cliente o pedido');
      return {
        success: false,
        error: 'La respuesta del servidor está incompleta',
        data: null,
        cliente: null,
        pedido: null
      };
    }

    return {
      success: true,
      data: { cliente, pedido },
      message: response?.mensaje || '✅ Registro exitoso',
      cliente,
      pedido
    };
  } catch (error) {
    console.error('❌ Error en registro web con pedido:', error);
    return {
      success: false,
      error: error?.message || 'Error al registrar',
      data: null,
      cliente: null,
      pedido: null
    };
  }
};

export const pedidoWebClienteExistente = async (data) => {
  try {
    console.log('📤 Enviando pedido web (cliente existente):', data);

    const response = await apiFetch('/api/ClienteGas/pedido-web', {
      method: 'POST',
      body: JSON.stringify(data)
    });

    console.log('📥 Respuesta del servidor:', response);

    const pedido = response?.data?.pedido || response?.data || null;

    if (!pedido) {
      return {
        success: false,
        error: 'La respuesta del servidor está incompleta',
        data: null,
        pedido: null
      };
    }

    return {
      success: true,
      data: { pedido },
      message: response?.mensaje || '✅ Pedido registrado',
      pedido
    };
  } catch (error) {
    console.error('❌ Error en pedido web:', error);
    return {
      success: false,
      error: error?.message || 'Error al registrar pedido',
      data: null,
      pedido: null
    };
  }
};

// =====================================================
// PEDIDOS DE RECARGA
// =====================================================
export const obtenerPedidosRecarga = async () => {
  try {
    const response = await apiFetch('/api/PedidoRecarga');
    const data = Array.isArray(response) ? response : (response?.data || []);
    return { success: true, data, count: data.length };
  } catch (error) {
    console.error('❌ Error obteniendo pedidos:', error);
    return { success: false, error: error?.message || 'Error al obtener pedidos', data: [], count: 0 };
  }
};

export const buscarPedidosRecarga = async (filtros) => {
  try {
    const response = await apiFetch('/api/PedidoRecarga/search', { method: 'POST', body: JSON.stringify(filtros) });
    const data = response?.data || response || [];
    return { success: true, data, count: data.length };
  } catch (error) {
    console.error('❌ Error buscando pedidos:', error);
    return { success: false, error: error?.message || 'Error en búsqueda', data: [], count: 0 };
  }
};

export const obtenerPedidoRecargaPorId = async (id) => {
  try {
    const response = await apiFetch(`/api/PedidoRecarga/${id}`);
    return { success: true, data: response };
  } catch (error) {
    console.error('❌ Error obteniendo pedido:', error);
    return { success: false, error: error?.message || 'Error al obtener pedido', data: null };
  }
};

export const crearPedidoRecarga = async (data) => {
  try {
    const response = await apiFetch('/api/PedidoRecarga', { method: 'POST', body: JSON.stringify(data) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Pedido creado' };
  } catch (error) {
    console.error('❌ Error creando pedido:', error);
    return { success: false, error: error?.message || 'Error al crear pedido', data: null };
  }
};

export const actualizarEstadoPedido = async (id, data) => {
  try {
    const response = await apiFetch(`/api/PedidoRecarga/${id}/estado`, { method: 'PUT', body: JSON.stringify(data) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Estado actualizado' };
  } catch (error) {
    console.error('❌ Error actualizando estado:', error);
    return { success: false, error: error?.message || 'Error al actualizar estado', data: null };
  }
};

export const cancelarPedidoRecarga = async (id, data) => {
  try {
    const response = await apiFetch(`/api/PedidoRecarga/${id}/cancelar`, { method: 'PUT', body: JSON.stringify(data) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Pedido cancelado' };
  } catch (error) {
    console.error('❌ Error cancelando pedido:', error);
    return { success: false, error: error?.message || 'Error al cancelar pedido', data: null };
  }
};

export const asignarDeliveryAPedido = async (id, data) => {
  try {
    const response = await apiFetch(`/api/PedidoRecarga/${id}/asignar-delivery`, { method: 'PUT', body: JSON.stringify(data) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Delivery asignado' };
  } catch (error) {
    console.error('❌ Error asignando delivery:', error);
    return { success: false, error: error?.message || 'Error al asignar delivery', data: null };
  }
};

export const asignarZonaAPedido = async (id, data) => {
  try {
    const response = await apiFetch(`/api/PedidoRecarga/${id}/asignar-zona`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
    return {
      success: true,
      data: response?.data || response,
      message: response?.mensaje || 'Zona asignada'
    };
  } catch (error) {
    console.error('❌ Error asignando zona:', error);
    return { success: false, error: error?.message || 'Error al asignar zona', data: null };
  }
};

export const verificarPagoPedido = async (id, data) => {
  try {
    const response = await apiFetch(`/api/PedidoRecarga/${id}/verificar-pago`, {
      method: 'POST',
      body: JSON.stringify(data)
    });
    return {
      success: true,
      data: response?.data || response,
      message: response?.mensaje || (data?.accion === 'rechazar' ? 'Pago rechazado' : 'Pago verificado')
    };
  } catch (error) {
    console.error('❌ Error verificando pago:', error);
    return { success: false, error: error?.message || 'Error al verificar pago', data: null };
  }
};

export const reportarPagoCliente = async (idPedidoRecarga, data) => {
  try {
    const response = await apiFetch(
      `/api/PedidoRecarga/${idPedidoRecarga}/reportar-pago`,
      {
        method: 'POST',
        body: JSON.stringify(data)
      }
    );
    return {
      success: true,
      data: response?.data || response,
      message: response?.mensaje || 'Pago reportado'
    };
  } catch (error) {
    console.error('❌ Error reportando pago:', error);
    return {
      success: false,
      error: error?.message || 'Error al reportar pago',
      data: null
    };
  }
};

export const consultarPedidoPorCedula = async (cedula) => {
  try {
    const response = await apiFetch(
      `/api/PedidoRecarga/consultar-por-cedula?cedula=${encodeURIComponent(cedula)}`,
      { method: 'GET' }
    );

    const pedido = response?.data !== undefined ? response.data : response;

    if (!pedido) {
      return { success: true, data: null, encontrado: false };
    }

    return {
      success: true,
      data: pedido,
      encontrado: true,
      message: response?.mensaje || 'Pedido encontrado'
    };
  } catch (error) {
    console.error('❌ Error consultando pedido por cédula:', error);
    return {
      success: false,
      error: error?.message || 'Error al consultar el pedido',
      data: null,
      encontrado: false
    };
  }
};

export const obtenerPedidosPorCliente = async (idClienteGas) => {
  try {
    const response = await apiFetch(`/api/PedidoRecarga/cliente/${idClienteGas}`);
    const data = Array.isArray(response) ? response : (response?.data || []);
    return { success: true, data };
  } catch (error) {
    console.error('❌ Error obteniendo pedidos por cliente:', error);
    return { success: false, error: error?.message || 'Error al obtener pedidos', data: [] };
  }
};

// =====================================================
// ⭐ DELIVERY ASIGNADO A UN PEDIDO (para el chatbot)
// =====================================================
export const obtenerDeliveryAsignado = async (idPedidoRecarga) => {
  try {
    const response = await apiFetch(`/api/PedidoRecarga/${idPedidoRecarga}/delivery-asignado`, {
      method: 'GET'
    });

    console.log('📦 [obtenerDeliveryAsignado] Respuesta:', response);

    // El backend devuelve { success, data, mensaje }
    if (response?.success === false) {
      return {
        success: false,
        data: null,
        error: response?.mensaje || 'No se pudo obtener el delivery'
      };
    }

    return {
      success: true,
      data: response?.data || null,
      message: response?.mensaje || 'Delivery obtenido'
    };
  } catch (error) {
    console.error('❌ Error obteniendo delivery asignado:', error);
    return {
      success: false,
      error: error?.message || 'Error al obtener el delivery',
      data: null
    };
  }
};

// =====================================================
// DELIVERY / REPARTIDORES
// =====================================================
export const obtenerDeliveries = async (filtro = 'all') => {
  try {
    let endpoint = '/api/Delivery';
    if (filtro === 'disponibles') endpoint = '/api/Delivery/disponibles';
    const response = await apiFetch(endpoint);
    const data = Array.isArray(response) ? response : (response?.data || []);
    return { success: true, data, count: data.length };
  } catch (error) {
    console.error('❌ Error obteniendo deliveries:', error);
    return { success: false, error: error?.message || 'Error al obtener deliveries', data: [], count: 0 };
  }
};

export const obtenerDeliveryPorId = async (id) => {
  try {
    const response = await apiFetch(`/api/Delivery/${id}`);
    return { success: true, data: response };
  } catch (error) {
    console.error('❌ Error obteniendo delivery:', error);
    return { success: false, error: error?.message || 'Error al obtener delivery', data: null };
  }
};

export const crearDelivery = async (data) => {
  try {
    const response = await apiFetch('/api/Delivery', { method: 'POST', body: JSON.stringify(data) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Delivery creado' };
  } catch (error) {
    console.error('❌ Error creando delivery:', error);
    return { success: false, error: error?.message || 'Error al crear delivery', data: null };
  }
};

export const actualizarDelivery = async (id, data) => {
  try {
    const response = await apiFetch(`/api/Delivery/${id}`, { method: 'PUT', body: JSON.stringify(data) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Delivery actualizado' };
  } catch (error) {
    console.error('❌ Error actualizando delivery:', error);
    return { success: false, error: error?.message || 'Error al actualizar delivery', data: null };
  }
};

export const eliminarDelivery = async (id) => {
  try {
    const response = await apiFetch(`/api/Delivery/${id}`, { method: 'DELETE' });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Delivery eliminado' };
  } catch (error) {
    console.error('❌ Error eliminando delivery:', error);
    return { success: false, error: error?.message || 'Error al eliminar delivery', data: null };
  }
};

export const actualizarDisponibilidadDelivery = async (id, disponible) => {
  try {
    const response = await apiFetch(`/api/Delivery/${id}/disponibilidad`, { method: 'PUT', body: JSON.stringify({ disponible }) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Disponibilidad actualizada' };
  } catch (error) {
    console.error('❌ Error actualizando disponibilidad:', error);
    return { success: false, error: error?.message || 'Error al actualizar disponibilidad', data: null };
  }
};

// =====================================================
// ASIGNACIONES DE DELIVERY
// =====================================================
export const obtenerAsignaciones = async () => {
  try {
    const response = await apiFetch('/api/AsignacionDelivery');
    const data = Array.isArray(response) ? response : (response?.data || []);
    return { success: true, data, count: data.length };
  } catch (error) {
    console.error('❌ Error obteniendo asignaciones:', error);
    return { success: false, error: error?.message || 'Error al obtener asignaciones', data: [], count: 0 };
  }
};

export const obtenerMisAsignaciones = async () => {
  try {
    const response = await apiFetch('/api/AsignacionDelivery/mis-asignaciones');
    const data = Array.isArray(response) ? response : (response?.data || []);
    return { success: true, data, count: data.length };
  } catch (error) {
    console.error('❌ Error obteniendo mis asignaciones:', error);
    return { success: false, error: error?.message || 'Error al obtener asignaciones', data: [], count: 0 };
  }
};

export const obtenerAsignacionesPorPedido = async (idPedidoRecarga) => {
  try {
    const response = await apiFetch(`/api/AsignacionDelivery/pedido/${idPedidoRecarga}`);
    const data = Array.isArray(response) ? response : (response?.data || []);
    return { success: true, data };
  } catch (error) {
    console.error('❌ Error obteniendo asignaciones por pedido:', error);
    return { success: false, error: error?.message || 'Error al obtener asignaciones', data: [] };
  }
};

export const obtenerAsignacionesPorDelivery = async (idDelivery) => {
  try {
    const response = await apiFetch(`/api/AsignacionDelivery/delivery/${idDelivery}`);
    const data = Array.isArray(response) ? response : (response?.data || []);
    return { success: true, data };
  } catch (error) {
    console.error('❌ Error obteniendo asignaciones por delivery:', error);
    return { success: false, error: error?.message || 'Error al obtener asignaciones', data: [] };
  }
};

export const aceptarAsignacion = async (id, data = {}) => {
  try {
    const response = await apiFetch(`/api/AsignacionDelivery/${id}/aceptar`, { method: 'PUT', body: JSON.stringify(data) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Asignación aceptada' };
  } catch (error) {
    console.error('❌ Error aceptando asignación:', error);
    return { success: false, error: error?.message || 'Error al aceptar asignación', data: null };
  }
};

export const rechazarAsignacion = async (id, motivo) => {
  try {
    const response = await apiFetch(`/api/AsignacionDelivery/${id}/rechazar`, { method: 'PUT', body: JSON.stringify({ motivoRechazo: motivo }) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Asignación rechazada' };
  } catch (error) {
    console.error('❌ Error rechazando asignación:', error);
    return { success: false, error: error?.message || 'Error al rechazar asignación', data: null };
  }
};

export const iniciarRutaAsignacion = async (id) => {
  try {
    const response = await apiFetch(`/api/AsignacionDelivery/${id}/iniciar-ruta`, { method: 'PUT' });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Ruta iniciada' };
  } catch (error) {
    console.error('❌ Error iniciando ruta:', error);
    return { success: false, error: error?.message || 'Error al iniciar ruta', data: null };
  }
};

export const marcarLlegadaAsignacion = async (id) => {
  try {
    const response = await apiFetch(`/api/AsignacionDelivery/${id}/llegada`, { method: 'PUT' });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Llegada registrada' };
  } catch (error) {
    console.error('❌ Error marcando llegada:', error);
    return { success: false, error: error?.message || 'Error al marcar llegada', data: null };
  }
};

// =====================================================
// ⭐ COMPLETAR ENTREGA — CON CÓDIGO DE ENTREGA
// =====================================================
export const completarEntregaAsignacion = async (id, data = {}) => {
  try {
    if (!data.codigoEntrega || !data.codigoEntrega.trim()) {
      return {
        success: false,
        error: 'Debes ingresar el código de entrega proporcionado por el cliente',
        data: null
      };
    }

    const payload = {
      codigoEntrega: data.codigoEntrega.trim(),
      tiempoRealMinutos: data.tiempoRealMinutos ?? null,
      propinaUsd: data.propinaUsd ?? null,
      propinaBs: data.propinaBs ?? null,
      observaciones: data.observaciones?.trim() || null
    };

    console.log('📤 Completando entrega con payload:', payload);

    const response = await apiFetch(`/api/AsignacionDelivery/${id}/completar`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });

    console.log('📥 Respuesta completar entrega:', response);

    return {
      success: true,
      data: response?.data || response,
      message: response?.mensaje || 'Entrega completada correctamente'
    };
  } catch (error) {
    console.error('❌ Error completando entrega:', error);

    const msg = error?.message || '';
    if (/código/i.test(msg) || /codigo/i.test(msg)) {
      return {
        success: false,
        error: msg,
        data: null,
        codigoInvalido: true
      };
    }

    return {
      success: false,
      error: msg || 'Error al completar entrega',
      data: null
    };
  }
};

// =====================================================
// PAGOS DE PEDIDO
// =====================================================
export const obtenerPagosPedidos = async () => {
  try {
    const response = await apiFetch('/api/PagoPedidoRecarga');
    const data = Array.isArray(response) ? response : (response?.data || []);
    return { success: true, data, count: data.length };
  } catch (error) {
    console.error('❌ Error obteniendo pagos:', error);
    return { success: false, error: error?.message || 'Error al obtener pagos', data: [], count: 0 };
  }
};

export const obtenerPagosPorPedido = async (idPedidoRecarga) => {
  try {
    const response = await apiFetch(`/api/PagoPedidoRecarga/pedido/${idPedidoRecarga}`);
    const data = Array.isArray(response) ? response : (response?.data || []);
    return { success: true, data };
  } catch (error) {
    console.error('❌ Error obteniendo pagos por pedido:', error);
    return { success: false, error: error?.message || 'Error al obtener pagos', data: [] };
  }
};

export const crearPagoPedido = async (data) => {
  try {
    const response = await apiFetch('/api/PagoPedidoRecarga', { method: 'POST', body: JSON.stringify(data) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Pago registrado' };
  } catch (error) {
    console.error('❌ Error creando pago:', error);
    return { success: false, error: error?.message || 'Error al registrar pago', data: null };
  }
};

export const anularPagoPedido = async (id, motivo) => {
  try {
    const response = await apiFetch(`/api/PagoPedidoRecarga/${id}/anular`, { method: 'PUT', body: JSON.stringify({ motivo }) });
    return { success: true, data: response?.data || response, message: response?.mensaje || 'Pago anulado' };
  } catch (error) {
    console.error('❌ Error anulando pago:', error);
    return { success: false, error: error?.message || 'Error al anular pago', data: null };
  }
};

// =====================================================
// HELPERS
// =====================================================
export const formatearFecha = (fechaISO, completo = false) => {
  if (!fechaISO) return 'N/A';
  try {
    const fecha = new Date(fechaISO);
    const opciones = { year: 'numeric', month: 'short', day: 'numeric' };
    if (completo) { opciones.hour = '2-digit'; opciones.minute = '2-digit'; }
    return fecha.toLocaleDateString('es-ES', opciones);
  } catch { return fechaISO; }
};

export const formatearMoneda = (valor, moneda = 'USD') => {
  if (valor === undefined || valor === null) return moneda === 'USD' ? '$0.00' : 'Bs. 0.00';
  const num = Number(valor);
  if (isNaN(num)) return moneda === 'USD' ? '$0.00' : 'Bs. 0.00';
  const formateado = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
  return moneda === 'USD' ? `$${formateado}` : `Bs. ${formateado}`;
};

export const colorEstadoPedido = (estado) => {
  const colores = {
    'PENDIENTE': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
    'CONFIRMADO': 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
    'PAGO_PENDIENTE': 'bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-300',
    'PAGO_VERIFICADO': 'bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-300',
    'ASIGNADO': 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300',
    'EN_CAMINO': 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300',
    'EN_PROCESO': 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
    'COMPLETADO': 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
    'CANCELADO': 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
    'RECHAZADO': 'bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-300'
  };
  return colores[estado] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
};

export const formatearCodigoEntrega = (codigo) => {
  if (!codigo) return '------';
  return String(codigo).padStart(6, '0');
};

export default {
  // Zonas
  obtenerZonas, obtenerZonaPorId, crearZona, actualizarZona, eliminarZona,

  // Tipos de recarga
  obtenerTiposRecarga, obtenerTipoRecargaPorId, crearTipoRecarga, actualizarTipoRecarga, eliminarTipoRecarga,
  convertirKilosALitros, convertirLitrosAKilos,

  // Tasa BCV
  obtenerTasaActual,

  // Clientes
  obtenerClientesGas, obtenerClienteGasPorId, buscarClientePorCedula,
  crearClienteGas, actualizarClienteGas, eliminarClienteGas, verificarClienteGas,

  // Registro web
  registroWebConPedido, pedidoWebClienteExistente,

  // Pedidos
  obtenerPedidosRecarga, buscarPedidosRecarga, obtenerPedidoRecargaPorId, crearPedidoRecarga,
  actualizarEstadoPedido, cancelarPedidoRecarga, asignarDeliveryAPedido,
  asignarZonaAPedido, verificarPagoPedido, reportarPagoCliente,
  consultarPedidoPorCedula, obtenerPedidosPorCliente,
  obtenerDeliveryAsignado,   // ⭐ NUEVO

  // Delivery
  obtenerDeliveries, obtenerDeliveryPorId, crearDelivery, actualizarDelivery, eliminarDelivery, actualizarDisponibilidadDelivery,

  // Asignaciones
  obtenerAsignaciones, obtenerMisAsignaciones,
  obtenerAsignacionesPorPedido, obtenerAsignacionesPorDelivery,
  aceptarAsignacion, rechazarAsignacion, iniciarRutaAsignacion, marcarLlegadaAsignacion, completarEntregaAsignacion,

  // Pagos
  obtenerPagosPedidos, obtenerPagosPorPedido, crearPagoPedido, anularPagoPedido,

  // Helpers
  formatearFecha, formatearMoneda, colorEstadoPedido, formatearCodigoEntrega
};